<template>
    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm12 md12>
          <v-card >
            <v-toolbar color="#f8f9fb" elevation="0">
              <v-toolbar-title>Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="$router.go(-1)">
          <v-icon left> mdi-chevron-double-left </v-icon>
          {{ `${this.$t("notice.edit.buttons.back")}` }}
        </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
  
            <v-card-text class="#f4f5f7">
              <v-data-table
                :headers="headers"
                :items="payment"
                :search="search"
                class="elevation-3"
              >
                <template v-slot:top>
                  <v-text-field
                    v-model="search"
                    label="Search"
                    clearable
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                    class="col-md-6"
                    @input="sessionStorage(search)"
                  ></v-text-field>
                </template>
                <template v-slot:item.purchase_date="{ item }"
                  >{{ dateFormatter(item.purchase_date) }}
                </template>
              
  
                <!-- <template v-slot:item.actions="{ item }">
                  <v-icon size="large" @click="openView(item.id)">
                    mdi-eye
                  </v-icon>
                  <v-icon size="large" @click="deleteItem(item.id)">
                    mdi-delete
                  </v-icon>
                </template> -->
              </v-data-table>
            </v-card-text>

            
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  import { mapMutations } from "vuex";
  import moment from "moment";
  
  export default {
    data() {
      return {
       
        search: "",
        headers: [
          {
            text: "Title",
            align: "start",
            value: "plan.title",
            width: "15%",
          },
          {
            text: "Society Name",
            align: "start",
            value: "society.name",
          },
          {
            text: "Person Name",
            align: "start",
            value: "society.contact_person_name",
          },
        
          {
            text: "Purchase Date",
            align: "center",
            value: "purchase_date",
          },
          {
            text: "Amount",
            align: "center",
            value: "amount",
          },
          {
            text: "Transaction id",
            align: "start",
            value: "transaction_id",
          },
        //   {
        //     text: `${this.$t("society.list.headers.actions")}`,
        //     value: "actions",
        //     width: "8%",
        //     sortable: false,
        //   },
        ],
        payment: [],
      };
    },
  
    methods: {
      ...mapMutations("alert", ["setAlert"]),
      getPayment() {
        let _self = this;
        _self.$axios.get("superadmin/payment").then((response) => {
          let data = response.data;
          if (data.status) {
            _self.payment = data.payment;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
      },
      dateFormatter(date) {
        return moment(date).format("DD/MM/YYYY");
      },
     


  
      sessionStorage(search) {
        if (search === null || search === "" || search === undefined) {
          sessionStorage.removeItem("payment_search");
        } else {
          sessionStorage.setItem("payment_search", search);
        }
      },
    },
    mounted() {
      this.getPayment();
      this.search = sessionStorage.getItem("payment_search");
    },
  };
  </script>
  